




















import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import ResponsavelUsuarioRequest from '@/model/request/ResponsavelUsuarioRequest'
import { ItrackCollection } from '@/helpers'
import Responsavel from '@/model/resource/Responsavel'
import {$} from 'simpli-web-sdk'
import * as Helper from '@/helpers/'

@Component
export default class FilterResponsavelUsuario extends Mixins(MixinMember) {
  @Prop({required: true}) value!: ResponsavelUsuarioRequest

  allFilial = ItrackCollection.allFilialFilter.prependNull('app.all')

  async mounted() {
    await this.allFilial.query()
    this.allFilial.items.forEach((item: Responsavel) => {
      let nomeFantasia = ''
      if (item.nomeFantasia) {
        nomeFantasia = `${$.filter.truncate(item.nomeFantasia || '', 20)} - `
      }

      item.$tag = `${nomeFantasia}${Helper.cnpj(item.cnpj)}`
    })
    this.value.filial = this.allFilial.get(this.value.idFilial)
    $.await.done('filterQuery')
  }
}
